export default __webpack_public_path__ + "static/media/pregnancy.221717a3.png";